<script lang="ts">
  import Link from "svelte-link";
  import { Label } from "sveltestrap";
  import FeatherIcons from "svelte-feather-icon";
  import { href } from "../../../../utils/Constant/Constant";
  import Counter from 'svelte-counter';
  export let likes: number;
  export let comments: number;
  export let shares: number;
  export let counters = {
    'like': likes,
    "comment": comments,
    "share":shares
  }
</script>
<ul class="post-comment">
    <li>
      <Label>
          <Link {href}>
              <Counter values={counters} duration="4000" random="false" minspeed="200" let:counterResult>
                  <FeatherIcons icon="heart" />  {'Like'}<span class="counter">{counterResult.like}</span>
              </Counter>
          </Link>
      </Label>
    </li>
    <li>
      <Label>
          <Link {href}>
            <Counter values={counters} duration="4000" random="false" minspeed="200" let:counterResult>
              <FeatherIcons icon="message-square" />  {'Comment'}<span class="counter">{counterResult.comment}</span>
            </Counter>
          </Link>
      </Label>
    </li>
    <li>
      <Label>
          <Link {href}>
            <Counter values={counters} duration="4000" random="false" minspeed="200" let:counterResult>
              <FeatherIcons icon="share" />  {'share'}<span class="counter">{counterResult.share}</span>
            </Counter>
          </Link>
      </Label>
    </li>
</ul>